<template lang="html">
  <ol class="nav-buttons">
    <slot>
      <li class="nav-button-item">
        <router-link :to="{ name: 'settings' }">Settings</router-link>
      </li>
      <li class="nav-button-item">
        <router-link :to="{ name: 'about' }">About</router-link>
      </li>
    </slot>
  </ol>
</template>

<script>
export default {
  name: 'NavButtons',
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';

$spacing-horizontal: 1em;

.nav-buttons {
  @include unstyled-list;

  flex-direction: column;
  margin: 0 -$spacing-horizontal;

  &.in-popover {
    padding: 0.5em 0;
    margin: 0;
  }
}

.nav-button-item {
  font-weight: map-get($font-weights, 'bold-1x');

  a {
    color: inherit;
    display: block;
    text-decoration: none;
    padding: 0.5em $spacing-horizontal;
  }
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  .nav-buttons {
    flex-direction: row;
  }

  .nav-button-item a {
    padding: 0.5em;
  }
}
</style>
